import type { TranslatedFields } from '@/interfaces/Language.interfaces'
import type { HexaColor } from '@/interfaces/Colors.interfaces'

export enum MeasureStatus {
  TO_IMPLEMENT = 'TO_IMPLEMENT',
  BEING_IMPLEMENTED = 'BEING_IMPLEMENTED',
  IMPLEMENTED = 'IMPLEMENTED',
}

export enum MeasureStatusAll {
  ALL = 'ALL',
}

export enum PolicyType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export type MeasuresStatusWithAll = MeasureStatus | MeasureStatusAll

export interface ApiSchema<T> {
  data: T
  meta?: object
  paging?: PagingType
}

export interface PagingType {
  page_count: number
  count: number
}

export type PolicyId = number

export interface PolicyBase {
  id: PolicyId
  identifier: string
  name: TranslatedFields
  public: boolean
}

export interface CatalogPolicy extends PolicyBase {
  measure_count: number
}

export interface Policy extends PolicyBase {
  perimeters: Perimeter[]
  score?: number // TODO Remove optionnal when back adds the score
}

export interface Quotas {
  perimeters: Quota
  policies: Quota
}

export interface Quota {
  max?: number | null
  current: number
}

export type PerimeterId = number

export interface Perimeter {
  id: PerimeterId
  identifier: string
  name: TranslatedFields
  score?: number // TODO Remove optionnal when back adds the score
}

export interface PerimeterScore {
  score: number
}

export interface Attachment {
  id: number
  parent_ids: number[]
  identifier: string
  name: TranslatedFields
}

export interface AttachmentTree extends Attachment {
  children?: AttachmentTree[]
}

export type MeasureId = string

export interface Measure {
  id: MeasureId
  name: TranslatedFields
  status: MeasureStatus
  score?: number
  description?: TranslatedFields
}

export type GetMeasuresResponse = ApiSchema<Measure[]>

export type SelectedMeasure = Measure & {
  ownerId: string | null
  perimeterName: string
  identifier: string
  categoryId: number | null
  cost: number | null
  charge: number | null
  builtId: number | null
}

export interface GetMeasureResponse {
  measure: SelectedMeasure
  editable: boolean
  canEditBuiltMeasure: boolean
}

export type PutMeasureRequest = Required<Omit<SelectedMeasure, 'id' | 'status' | 'score' | 'perimeterName'>>

export type GetPerimeterScore = ApiSchema<PerimeterScore>

export interface GroupUser {
  id: string
  obj_id: number
  name: string
  email: string | null
  perimeters: number[]
  edit_right: boolean
  is_group: boolean
  user_in_group?: boolean
  is_staff: boolean
  is_pilote: boolean
}

export interface GetGroupUsersResponse {
  ok: true
  message: string
  objects: GroupUser[]
}

export interface Category {
  id: number
  name: string
  identifier: string
  color: HexaColor
}

export interface GetCategoriesResponse {
  ok: true
  total: number
  add_right: boolean
  objects: Category[]
}

export interface Runtask {
  id: number
  identifier: string
  name: string
}

export interface Indicator {
  id: number
  identifier: string
  name: string
}

export interface Solution {
  id: number
  name: string
  description: string
  is_catalog: boolean
  public: boolean
  runtasks: Runtask[]
  indicators: Indicator[]
  identifier: string
  edit_right: boolean
  view_right: boolean
  ref: string
}

export interface GetSolutionsResponse {
  ok: true
  total: number
  objects: Solution[]
}
